import { useMutation, useQueryClient } from "@tanstack/react-query";

import { addFieldSimulation } from "services";

import { ADD_FIELD_SIMULATION, GET_FIELD_SIMULATIONS } from "consts";

export const useAddFieldSimulation = ({ fieldId, name }: { fieldId: string; name: string }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [ADD_FIELD_SIMULATION],
    mutationFn: () => addFieldSimulation({ fieldId, name }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_FIELD_SIMULATIONS] });
    },
  });
};
